import request from '../request'

export default {
  getFileTypes: function () {
    return request.get('fileTypes')
  },

  getFiles: function () {
    return request.get('files')
  },

  uploadFile: function (formData, progressCallback) {
    const config = {
      onUploadProgress: progressEvent => {
        let percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        progressCallback(percentage)
      }
    }
    return request.post('files', formData, config)
  },

  downloadFile: function (file, toast = null) {
    const config = {
      onDownloadProgress: progressEvent => {
        let percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total)

        if (toast) {
          toast.progressBarValue = percentage
        }
      },
      responseType: 'blob'
    }
    return request.get(`files/${file.ID_FICHERO}`, config)
  },

  getFileMapTiff: function (file) {
    return request.get(`fileMapTiff/${file.ID_FICHERO}`, {
      responseType: 'arraybuffer'
    })
  },

  getFileMapPng: function (file) {
    return request.get(`fileMapPng/${file.ID_FICHERO}`)
  },

  deleteFile: function (file) {
    return request.delete(`files/${file.ID_FICHERO}`)
  }
}
